"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploader = void 0;
var _core = require("@emotion/core");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _constants = require("../constants");
var _helpers = require("../helpers");
var _ImageUploaderCatalogs = require("../i18n/ImageUploaderCatalogs");
var _UploadContainerStyled = require("../styled/UploadContainerStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
var _EmptyImageUploadBox = require("./EmptyImageUploadBox");
var _FulfilledImageButtonGroup = require("./FulfilledImageButtonGroup");
var _ImageDropzone = require("./ImageDropzone");
var _ImageUploadErrorAlert = require("./ImageUploadErrorAlert");
var _UploadedImageShow = require("./UploadedImageShow");
const ImageUploaderBase = /*#__PURE__*/(0, _react.forwardRef)((_ref, uploaderRef) => {
  let {
    acceptableFileTypes = _constants.DEFAULT_ACCEPTABLE_FILE_TYPES,
    className,
    clientId,
    defaultImageSrc,
    fulfilledState,
    isDisabled,
    locale,
    maxBytes = _constants.DEFAULT_MAX_BYTES,
    minBytes = _constants.DEFAULT_MIN_BYTES,
    onChange,
    usageType = "image"
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [error, setError] = (0, _react.useState)(null);
  const [imageDimensions, setImageDimensions] = (0, _react.useState)(null);
  const [uploadedFileResult, setUploadedFileResult] = (0, _react.useState)(null);
  const acceptableMimeTypes = (0, _helpers.getConvertedMimeTypes)(acceptableFileTypes);
  const imageSrcToShow = uploadedFileResult?.imagePreviewUrl || defaultImageSrc;
  const calculateImageDimensions = (0, _react.useCallback)(() => {
    if (!imageSrcToShow) return;
    const img = new Image();
    img.onload = function () {
      setImageDimensions({
        height: img.height,
        width: img.width
      });
    };
    img.src = imageSrcToShow;
  }, [imageSrcToShow]);
  const calculateDropzoneHeight = () => {
    if (usageType === "image") return _imageUploaderTheme.imageUploaderTheme.dropZoneHeight.image(themeMode);else if (!imageDimensions) return _imageUploaderTheme.imageUploaderTheme.dropZoneHeight.logo(themeMode);else if (imageDimensions.height > imageDimensions.width) return _imageUploaderTheme.imageUploaderTheme.dropZoneHeight.logoLarge(themeMode);else return _imageUploaderTheme.imageUploaderTheme.dropZoneHeight.logo(themeMode);
  };
  const dropzoneHeight = calculateDropzoneHeight();
  (0, _react.useEffect)(() => {
    calculateImageDimensions();
  }, [calculateImageDimensions]);
  const processFile = async file => {
    const [fileAsURL, fileMimeType] = await Promise.all([(0, _helpers.loadFileAsURL)(file), (0, _helpers.getFileMimeType)(file)]);
    if (!acceptableMimeTypes.includes(fileMimeType)) {
      setError({
        fileName: file.name,
        type: "UNSUPPORTED_FILE_TYPE"
      });
    } else {
      setUploadedFileResult({
        file,
        imagePreviewUrl: fileAsURL
      });
      setError(null);
      onChange(file);
    }
  };
  const handleChangeFile = file => {
    const {
      size: fileSize,
      name: fileName
    } = file;
    if (minBytes && fileSize < minBytes) {
      setError({
        fileName,
        type: "SMALLER_THAN_MIN_SIZE"
      });
      return;
    } else if (maxBytes && fileSize > maxBytes) {
      setError({
        fileName,
        type: "LARGER_THAN_MAX_SIZE"
      });
      return;
    } else if (!acceptableMimeTypes.includes(file.type)) {
      setError({
        fileName,
        type: "UNSUPPORTED_FILE_TYPE"
      });
      return;
    }
    void processFile(file);
  };
  const handleRemoveFile = () => {
    setUploadedFileResult(null);
    setError(null);
    onChange(null);
  };
  return /*#__PURE__*/_react.default.createElement(_i18n.I18nContextProvider, {
    locale: locale
  }, /*#__PURE__*/_react.default.createElement(_core.ClassNames, null, _ref2 => {
    let {
      cx
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_UploadContainerStyled.UploadContainerStyled, {
      ref: uploaderRef,
      "data-client-id": clientId,
      className: cx(className, usageType === "logo" ? _constants.LOGO_CLASS : _constants.IMAGE_CLASS),
      themeMode: themeMode
    }, /*#__PURE__*/_react.default.createElement(_ImageDropzone.ImageDropzone, {
      acceptableMimeTypes: acceptableMimeTypes,
      clientId: (0, _lodestarUtils.getClientId)(clientId, "dropzone"),
      height: dropzoneHeight,
      isDisabled: isDisabled,
      onDrop: handleChangeFile,
      usageType: usageType
    }, imageSrcToShow ? /*#__PURE__*/_react.default.createElement(_UploadedImageShow.UploadedImageShow, {
      acceptableMimeTypes: acceptableMimeTypes,
      clientId: (0, _lodestarUtils.getClientId)(clientId, "uploaded-image"),
      imageSrc: imageSrcToShow,
      isDisabled: isDisabled,
      onChange: handleChangeFile,
      uploadedFileName: uploadedFileResult?.file?.name,
      usageType: usageType
    }) : /*#__PURE__*/_react.default.createElement(_EmptyImageUploadBox.EmptyImageUploadBox, {
      acceptableMimeTypes: acceptableMimeTypes,
      clientId: (0, _lodestarUtils.getClientId)(clientId, "empty-image"),
      isDisabled: isDisabled,
      onChange: handleChangeFile,
      usageType: usageType
    })), imageSrcToShow && /*#__PURE__*/_react.default.createElement(_FulfilledImageButtonGroup.FulfilledImageButtonGroup, {
      acceptableMimeTypes: acceptableMimeTypes,
      clientId: (0, _lodestarUtils.getClientId)(clientId, "fulfilled-image"),
      defaultImageSrc: defaultImageSrc,
      imagePreviewUrl: uploadedFileResult?.imagePreviewUrl,
      fulfilledState: fulfilledState,
      isDisabled: isDisabled,
      isLogoUploader: usageType === "logo",
      onChange: handleChangeFile,
      onRemove: handleRemoveFile
    }), error && /*#__PURE__*/_react.default.createElement(_ImageUploadErrorAlert.ImageUploadErrorAlert, {
      acceptableFileTypes: acceptableFileTypes,
      error: error,
      minBytes: minBytes,
      maxBytes: maxBytes,
      clientId: clientId
    }));
  }));
});
const ImageUploader = (0, _i18n.withTranslationInjection)(ImageUploaderBase, _ImageUploaderCatalogs.injectCatalog);
exports.ImageUploader = ImageUploader;
ImageUploaderBase.displayName = "ImageUploader";
//# sourceMappingURL=ImageUploader.js.map